const TOOL_RESULT_QUERY_TOOL_ID = "alpharun:tool_result_query";
const TOOL_RESULT_QUERY_TOOL_NAME = "tool_result_query";
const TOOL_RESULT_QUERY_TOOL_DISPLAY_NAME = "Stored result lookup";
export {
  TOOL_RESULT_QUERY_TOOL_DISPLAY_NAME,
  TOOL_RESULT_QUERY_TOOL_ID,
  TOOL_RESULT_QUERY_TOOL_NAME
};
//# sourceMappingURL=toolResultQuery.js.map
